import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IExportPaymentsRequest } from "@shared/lib/types/briefCampains";
import {
  PAYOUT_EXPORTS_QUERY_KEY,
  PAYOUTS_FACETS_QUERY_KEY,
  PAYOUTS_QUERY_KEY,
} from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useCreatePayoutExport() {
  const {
    mutate: createPayoutExport,
    isLoading: isCreating,
    isSuccess: isCreated,
  } = useMutation({
    mutationFn: async (request: IExportPaymentsRequest) => {
      return await CampaignService.createVendorPaymentsBankVerificationExport(
        request
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    onSuccess: (client) => {
      ToastService.success("Payment export created");
      setTimeout(() => {
        client.invalidateQueries({ queryKey: [...PAYOUT_EXPORTS_QUERY_KEY()] });
        client.invalidateQueries({ queryKey: [...PAYOUTS_QUERY_KEY()] });
        client.invalidateQueries({ queryKey: [...PAYOUTS_FACETS_QUERY_KEY()] });
      }, 1000);
    },
    options: { skipInvalidation: true },
  });

  return {
    createPayoutExport,
    isCreating,
    isCreated,
  };
}
